import apiConfig from "../../apiConfig";

export const deleteActivitySegment = async (at, segmentId) => {
	const response = await apiConfig.post(
		"/API/ADMINISTRATION/LICENSES/ACTIVITIES/Del_License_Segment",
		{
			License_Segment_Id: segmentId,
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	if (response.data.Status) {
		return response.data;
	}

	return [];
};
